import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Table,
  Form,
} from "react-bootstrap";
import {
  FaEdit,
  FaTrash,
  FaPlus,
  FaEye,
  FaMoneyBill,
  FaUpload ,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { usePagination } from "../hooks/usePagination";
import Pagination from "../Components/Pagination";
import "./CustomerList.css";
import user from "../Assets/user.png";
import userMaleImg from "../Assets/m-user.png";
import userFemaleImg from "../Assets/f-user.png";
import axios from "axios";

const CustomerList = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [search, setSearch] = useState("");
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  // const [userImg, setUserImg] = useState("");


  const filteredCustomers = customers.filter((c) => {
    if (!search) return true;
    const q = search.toLowerCase();
    return (
      String(c.id).toLowerCase().includes(q) ||
      (c.name && c.name.toLowerCase().includes(q)) ||
      (c.email && c.email.toLowerCase().includes(q)) ||
      (c.depart_name && c.depart_name.toLowerCase().includes(q)) ||
      (c.desig_name && c.desig_name.toLowerCase().includes(q)) ||
      (c.staff_type && c.staff_type.toLowerCase().includes(q))
    );
  });

  // Use the pagination hook
  const {
    currentPage,
    totalPages,
    currentItems: currentCustomers,
    handlePageChange,
    indexOfFirstItem
  } = usePagination(filteredCustomers, 25); // 2 items per page

  const handleDelete = (user_id) => {
    setLoading(true);
    // setCustomers(customers.filter((c) => c.user_id !== user_id));
    axios.post(`${API_BASE_URL}user_delete.php`, { user_id: user_id })
      .then((response) => {
        if (response.data.head.code === 200) {
          // setCustomers(response.data.body);
          // setFilteredOrders(response.data.body);
          window.location.reload();
          setLoading(false);
        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          // setCustomers([]);
          // setFilteredOrders([]);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        // setCustomers([]);
        // setFilteredOrders([]);
        setLoading(false);
      }).finally(() => {
        setLoading(false); // Set loading to false after API call
      });
  };

  useEffect(() => {
    axios.post(`${API_BASE_URL}user_list.php`)
      .then((response) => {
        if (response.data.head.code === 200 && Array.isArray(response.data.body)) {
          setCustomers(response.data.body);
          // setFilteredOrders(response.data.body);
          
          setLoading(false);
        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setCustomers([]);
          // setFilteredOrders([]);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setCustomers([]);
        // setFilteredOrders([]);
        setLoading(false);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
        setLoading(false);
      });
  }, []);
  // if (!currentCustomers) {
  //       return (
  //         <Container fluid className="outer-container my-4">
  //           <h2 className="text-center mb-3">View Task</h2>
  //           <Row>
  //             <Col>
  //               <div className="not-found-box">Loading...</div>
  //             </Col>
  //           </Row>
  //         </Container>
  //       );
  //     }
  return (

    <Container fluid className="outer-container my-3">
      <h2 className="text-center mb-3">User Management</h2>
      {currentCustomers.length === 0 && (
        <Container fluid className="outer-container my-4">
          <Row>
            <Col>
              <div className="not-found-box">Loading...</div>
            </Col>
          </Row>
        </Container>
      )}
      <Row className="mb-3 align-items-center">
        <Col xs={12} md={6} lg={4} className="mb-2 mb-md-0">
          <Form.Control
            placeholder="Search User"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Col>

        <Col
          xs={12}
          md={6}
          lg={8}
          className="d-flex justify-content-md-end mt-2 mt-md-0"
        >
          <Link
            to="/addcustomer"
            className="btn-top d-inline-flex align-items-center"
          >
            <FaPlus className="me-2" /> Add User
          </Link>
          <div style={{width:"10px"}}> </div>
          <Link
            to="/importcustomer"
            className="btn-top d-inline-flex align-items-center"
          >
            <FaUpload className="me-2" /> Import User
          </Link>
        </Col>
      </Row>




      {/* Scrollable table container */}
      <div className="table-pagination-wrapper">
        <div className="table-pagination-content">
          <Table bordered responsive className="table-striped customer-table">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Photo</th>
                <th>Name</th>
                <th>Email</th>
                <th>Department</th>
                <th>Designation</th>
                <th>Staff Type</th>
                <th>Salary</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentCustomers.map((item, i) => {
                const userImg = item.gender === "Male" ? userMaleImg : userFemaleImg;
                return (
                
                <tr key={item.user_id}>
                  <td>{indexOfFirstItem + i + 1}</td>
                  <td>
                    <img src={item.image || userImg} alt={item.name} className="user-photo" />
                  </td>
                  <td>{item.name}</td>
                  <td>{item.email}</td>
                  <td>{item.depart_name}</td>
                  <td>{item.desig_name}</td>
                  <td>{item.staff_type}</td>
                  <td>
                    {item.staff_type && item.staff_type.toLowerCase().includes("aided") ? (
                      <Link
                        to={`/salary-aided/${item.user_id}`}
                        className="me-2"
                        title={`View ${item.name} aided salary`}
                      >
                        <FaMoneyBill className="salary-icon" />
                      </Link>
                    ) : (
                      <Link
                        to={`/salary/${item.user_id}`}
                        className="me-2"
                        title={`View ${item.name} salary`}
                      >
                        <FaMoneyBill className="salary-icon" />
                      </Link>
                    )}
                  </td>
                  <td>
                    <div className="action-icons">
                      <Link
                        to={`/viewcustomer/${item.user_id}`}
                        className="me-2"
                        title="View"
                      >
                        <FaEye className="view-icon" />
                      </Link>
                      <Link
                        to={`/editcustomer/${item.user_id}`}
                        className="me-2"
                        title="Edit"
                      >
                        <FaEdit className="edit-icon" />
                      </Link>
                      <FaTrash
                        className="delete-icon"
                        title="Delete"
                        // onClick={() => handleDelete(item.user_id)}
                        onClick={() => {
                          if (window.confirm("Are you sure you want to delete this?")) {
                            handleDelete(item.user_id);
                          }
                        }}
                      />
                    </div>
                  </td>
                </tr>
              ) }
              )}

            </tbody>
          </Table>
        </div>
      </div>

      {/* Common Pagination Component - Only show if more than 1 page */}
      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      )}
    </Container>
  );
};

export default CustomerList;